'use es6';

import { Fragment } from 'react';
import { HR } from 'foundations-components/transitional/components/HR';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import CaptchaToggle from 'FormsUI/components/editor/leftPanel/properties/CaptchaToggle';
import LegalConsentSelect from 'FormsUI/components/editor/leftPanel/properties/LegalConsentSelect';
import AdConsentProperties from 'FormsUI/components/editor/leftPanel/properties/AdConsentProperties';
import { CommentableArea } from 'collaboration-sidebar';
import { CAPTCHA_TOGGLE_MODULE_ID, LEGAL_CONSENT_SELECT_MODULE_ID, ADS_CONSENT_MODULE_ID } from 'FormsUI/constants/Commenting';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { TOGGLE_PROPERTY_ACCORDION } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLangKey = sufix => `editor.form.properties.${sufix}`;
const OtherFormFlements = ({
  captchaEnabled = false,
  captchaConfigurable = false,
  hasAdConsentAccess = false,
  handleCaptchaSelect = () => {},
  currentLegalConsentOption = '',
  selectLegalConsent = () => {},
  defaultOpen = false
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(Flex, {
    padding: "600",
    paddingBlockStart: "800",
    justifyContent: "space-between",
    children: /*#__PURE__*/_jsx("div", {
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/_jsx(Box, {
        grow: 1,
        shrink: 0,
        children: /*#__PURE__*/_jsxs(AccordionItem, {
          id: "other-elements-accordion",
          "data-test-id": "other-elements-accordion",
          defaultOpen: defaultOpen,
          title: /*#__PURE__*/_jsx(Fragment, {
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h7",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: getLangKey('otherFormElements')
                })
              }), "(", /*#__PURE__*/_jsx(FormattedMessage, {
                message: getLangKey('otherFormElementsSubtitle')
              }), ")"]
            })
          }),
          onOpenChange: isOpen => {
            trackEditorInteraction(TOGGLE_PROPERTY_ACCORDION, {
              value: ['other-form-elements', ...(isOpen ? ['isOpened'] : ['isClosed'])]
            });
          },
          children: [/*#__PURE__*/_jsx(CommentableArea, {
            moduleId: CAPTCHA_TOGGLE_MODULE_ID,
            description: {
              translationKey: 'formsCaptchaToggle'
            },
            children: /*#__PURE__*/_jsx(CaptchaToggle, {
              captchaEnabled: captchaEnabled,
              captchaConfigurable: captchaConfigurable,
              handleCaptchaSelect: handleCaptchaSelect
            })
          }), /*#__PURE__*/_jsx(CommentableArea, {
            moduleId: LEGAL_CONSENT_SELECT_MODULE_ID,
            description: {
              translationKey: 'formsGDPROptions'
            },
            children: /*#__PURE__*/_jsx(LegalConsentSelect, {
              selectLegalConsentOption: selectLegalConsent,
              currentLegalConsentOption: currentLegalConsentOption
            })
          }), hasAdConsentAccess ? /*#__PURE__*/_jsx(CommentableArea, {
            moduleId: ADS_CONSENT_MODULE_ID,
            description: {
              translationKey: 'formsContentModuleId'
            },
            children: /*#__PURE__*/_jsx(AdConsentProperties, {})
          }) : null]
        })
      })
    })
  }), /*#__PURE__*/_jsx(HR, {
    margin: "0"
  })]
});
export default OtherFormFlements;